import { render } from "./DayManagement.vue?vue&type=template&id=4c460b44"
import script from "./DayManagement.vue?vue&type=script&lang=js"
export * from "./DayManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__